import { httpAction, store_orders_api, store_login_api, store_details_api, store_packages_api, changepwd_api, store_purchase_online_api, store_book_api } from "./http";
import {getToken} from "../store";

// export const login 
export const storeLogin = (data) => {
    return httpAction("LOGIN", {
        method: "POST",
        url: store_login_api,
        data,
        headers: {
            "Content-type": "application/json"
        }
    })
}

//store order
export const storeOrder = () => {
    let token = getToken();
    return httpAction("STORE_ORDER", {
        method: "POST",
        url: store_orders_api,
        headers: {
            "Authorization": `Token ${token}`,
            "Content-type": "application/json"
        }
    })
}

export const retrieveStoreDetails = () => {
    let token = getToken();
    return httpAction("STORE_DETAILS", {
        method: "GET",
        url: store_details_api,
        headers: {
            "Authorization": `Token ${token}`
        }
    })
}

//book 
export const book = (data) => {
    let token = getToken();
    return httpAction("STORE_BOOK", {
        method: "POST",
        url: store_book_api,
        data,
        headers: {
            "Authorization": `Token ${token}`,
            "Content-type": "application/json"
        }
    })
}

export const clearBook = () => {
    return {
        type: "STORE_BOOK_CLEAR"
    }
}

//list packages
export const storePackages = (is_recharge) => {
    let token = getToken();
    return httpAction(`STORE_PACKAGES_${is_recharge ? "RECHARGE" : "TOPUP"}`, {
        method: "GET",
        url: `${store_packages_api}?is_recharge=${is_recharge}`,
        headers: {
            "Authorization": `Token ${token}`
        }
    })
}

//purchase package
export const purchasePackage = (id) => {
    let token = getToken();
    return httpAction("PURCHASE_PACKAGE", {
        method: "GET",
        url: store_packages_api + id + "/purchase_package/",
        headers: {
            "Authorization": `Token ${token}`
        }
    })
}

export const clearPurchase = () => {
    return {
        type: 'PURCHASE_PACKAGE_CLEAR'
    }
}

//purchase success
export const purchaseOnline = (data) => {
    let token = getToken();
    return httpAction("PURCHASE_ONLINE", {
        method: "POST",
        url: store_purchase_online_api,
        data,
        headers: {
            "Authorization": `Token ${token}`,
            "Content-type": "application/json"
        }
    })
}

export const purchaseOnlineClear = () => {
    return {
        type: "PURCHASE_ONLINE_CLEAR"
    }
}


//change password
export const changePassword = (data) => {
    let token = getToken();
    return httpAction("CHANGE_PWD", {
        method: "POST",
        url: changepwd_api,
        data,
        headers: {
            "Authorization": `Token ${token}`,
            "Content-type": "application/json"
        }
    })
}